module.exports = __webpack_public_path__ + "static/img/2013.d9dbd51.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2013.png
// module id = hTy0
// module chunks = 1